var ace = require('ace-builds/src-noconflict/ace'); require('ace-builds/src-noconflict/ext-language_tools'); module.exports = ace.require('ace/editor').Editor